import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import {
  getPartyApi,
  getCubeList,
  getUserByRoleId,
  getAssignCubesFillerToMachinOperators,
} from "api";
import { Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import moment from "moment";
import { withTranslation } from "react-i18next";

class FillerAssignCubeDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 10,
      totalSize: 10,
      validation: "",
      editRowIndex: -1,
      date: moment().format("YYYY-MM-DD"),
      stockList: [],
    };
  }
  async componentDidMount() {
    this.getStockList();
  }
  async getStockList() {
    const stock = await getAssignCubesFillerToMachinOperators({
      page: this.state.page,
      limit: this.state.sizePerPage,
      date: null,

    });
    if(stock && stock.data){
      this.setState({
        totalSize: stock.data.count,
        stockList: stock.data.cubeBelts,
      });
    }
    
  }

  render() {
    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                this.getStockList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize,
      custom: true,
    };
  
    const { SearchBar } = Search;
    this.columns1 = [
      {
        dataField: "id",
        text: "#",
        hidden:true
      },
      {
        dataField: "machineOperatorId",
        text: `${this.props.t('Machine Operator')}`,
        sort: true,
        formatter: (cell, row) => {
          return row.user.name;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t('Assigned Date')}`,
        sort: true,
        formatter: (cell, row) => {
          return moment(cell).format("DD/MM/YYYY");
        },
      },
      {
        dataField: "remarks",
        text: this.props.t('Filler Notes'),
        sort: true,
      },
      {
        dataField: "viewdetail",
        text:`${this.props.t('View Details')}`,
        formatter: (cell, row) => (
          <div className="btn-group">
            <Link
              to={{
                pathname: "/filler-edit-filling-process",
                query: { isEdit: 2, data: row },
              }}
            >
              <button className="py-2 px-2 border-0 rounded">
                <img src="images/dashboard-images/edit.svg" />
              </button>
            </Link>
            <Link
              to={{
                pathname: "/filler-edit-filling-process",
                query: { isView: 3, data: row },
              }}
            >
              <button className="py-2 px-2 border-0 rounded ms-2">
                <img src="images/dashboard-images/view.svg" />
              </button>
            </Link>
          </div>
        ),
      },
    ];
    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];
    document.title = "filler flow";
    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={this.columns1}
        data={this.state.stockList}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={this.columns1}
            data={this.state.stockList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {this.props.t('My Stock List')}
                    </h3>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                              <div className="">
                                <h4 className="text-black fw-bold">
                                  {this.props.t('My Stock List')}
                                </h4>
                              </div>
                            </div>

                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                              <div>
                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">{this.props.t('Show')}</p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>

                                  <p className="d-inline ps-3 fs-5">{this.props.t('entries')}</p>
                                </div>
                              </div>
                            </div>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={true}
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    onTableChange={() => false}
                                    defaultSorted={defaultSorted}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                              <div className="">
                                <h5>
                                  {this.props.t('Showing')}{" "}
                                  {(this.state.page - 1) *
                                    this.state.sizePerPage +
                                    1}
                                  -{" "}
                                  {this.state.totalSize < this.state.sizePerPage
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                        this.state.page >=
                                      this.state.totalSize
                                    ? this.state.totalSize
                                    : this.state.sizePerPage * this.state.page}
                                  of {this.state.totalSize}
                                </h5>
                              </div>
                              <div className="ms-auto">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
    // return (
    //   <React.Fragment>
    //     <div className="page-content">
    //       <Container fluid={true}>
    //         <Breadcrumbs breadcrumbItem="Assigned Belt Details" />

    //         <Card className="pt-4 px-3">
    //           <div className="d-lg-flex d-block justify-content-between">
    //             <div>
    //               <h4 className="pb-3 text-black fw-bold">
    //                 Assigned Belt Details
    //               </h4>
    //             </div>
    //             <div className="mb-3 row">
    //               <label htmlFor="date" className="col-12 col-sm-2 col-lg-5">
    //                 <h5 className="fs-5 fw-bold text-black"> Assign Date:</h5>
    //               </label>
    //               <div className="col-12 col-sm-5 col-lg-7">
    //                 <input
    //                   onChange={e => {
    //                     this.setState({ date: e.target.value }, () => {
    //                       this.getStockList();
    //                     });
    //                   }}
    //                   className="border-0 fs-5"
    //                   type="date"
    //                   name="date"
    //                   defaultValue={moment().format("YYYY-MM-DD")}
    //                 />
    //               </div>
    //             </div>
    //           </div>

    //           <div className="row">
    //             <div className="table-responsive">
    //               <BootstrapTable
    //                 keyField="id"
    //                 bordered={false}
    //                 striped={false}
    //                 data={this.state.stockList}
    //                 columns={this.columns1}
    //               />
    //             </div>
    //           </div>
    //         </Card>
    //       </Container>
    //     </div>
    //   </React.Fragment>
    // );
  }
}

export default withTranslation()(FillerAssignCubeDetail);
